import { useState, useEffect,useRef } from 'react';
import { useTranslation } from 'react-i18next';
import WelcomeScreen from './components/WelcomeScreen';
import Header from './components/Header';
import AnalyzerContainer from './components/AnalyzerContainer';
import Footer from './components/Footer';
import ReferralBanner from './components/ReferralBanner';
import { LegalModals } from './components/LegalModals';
import { useAuthStore } from './stores/auth.store';
import { useSubscription } from './hooks/useSubscription';
import { Subscription } from './stores/subscription.store';
// import { useProfile } from './hooks/useProfile';
// import { useCV } from './hooks/useCV';
import { supabase } from './lib/supabase';
import { useAuth } from './hooks/useAuth';
// import { Subscription} from './hooks/useSubscription';
import PrivacyPolicy from './pages/PrivacyPolicy';
import GeneralTerms from './pages/GeneralTerms';
import LegalNotice from './pages/LegalNotice';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Logo from './assests/favicon-logo.png'
import ResetPassword from './components/ResetPassword';
import Loading from './components/sub-components/Loading/Loading'; 

function App() {
  useAuth();
  const { user, loading: authLoading, signOut,error } = useAuthStore();
const { subscription, refetch: refetchSubscription, setSubscription, reset: resetSubscription } = useSubscription();

  // const { loading: profileLoading } = useProfile();
  // const { loading: cvLoading } = useCV();
  const { t } = useTranslation();
  const [showReferralBanner, setShowReferralBanner] = useState(true);

  // Check if referral banner should be displayed
  const resetCalledRef = useRef(false);

useEffect(() => {
  if (authLoading) return;
  
  if (user?.id) {
    resetCalledRef.current = false; // Reset the flag when user logs in
    refetchSubscription();
  } else if (!resetCalledRef.current) {
    resetCalledRef.current = true; // Prevent multiple calls
    resetSubscription();
  }
}, [authLoading, user?.id, refetchSubscription, resetSubscription]);



  useEffect(() => {
    if (!user?.id) return;
    const channel = supabase
      .channel('subscriptionUpdate')
      .on(
        'postgres_changes',
        {
          event: 'UPDATE',
          schema: 'public',
          table: 'user_analyses',
          filter: `user_id=eq.${user?.id}`
        }, (payload) => {
          // Refetch subscription when a change is detected
          setSubscription(payload?.new as Subscription)
        
        })
        .subscribe();

        return () => {
          if(channel){
            supabase.removeChannel(channel)
          }
        }
  }, [user?.id, setSubscription])

  const handleLogout = async () => {
    try {
      await signOut(); // this now resets store properly
      localStorage.removeItem('cv_analyzer_referral_banner_dismissed');
    } catch (error) {
      console.error(t('app.logout_error'), error);
    }
  };

  const handleCloseBanner = () => {
    setShowReferralBanner(false);
    // localStorage.setItem('cv_analyzer_referral_banner_dismissed', 'true');
  };

  // Loading screen
  if(authLoading && !user) {    
    return <Loading />;
  }

  // Welcome screen if not authenticated
  if (!user) {
    return (
      <BrowserRouter>
        <Routes>
          <Route
            path="/"
            element={
              <>
                <WelcomeScreen onAuthComplete={() => {}} />
                <Footer />
                <LegalModals/>
              </>
            }
          />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-and-conditions" element={<GeneralTerms />} />
          <Route path="/legal-notice" element={<LegalNotice />} />
        </Routes>
      </BrowserRouter>
    );
  }

  // Main application if authenticated
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/"
          element={
            <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-200 flex flex-col">
              {/* Referral banner */}
              {/* {showReferralBanner && (
                <ReferralBanner onClose={handleCloseBanner} />
              )} */}

              <div className="flex-1 py-6 px-4">
                <div className="max-w-6xl mx-auto bg-white rounded-2xl shadow-xl overflow-hidden">
                  <Header onLogout={handleLogout}/>
                  <AnalyzerContainer subscription={subscription} />
                </div>
              </div>

              <Footer />
              {/* //TODO: Uncomment this when the PWA is ready */}
              {/* <PWAInstallBanner /> */}
              <LegalModals />
            </div>
          }
        />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route
          path="/privacy-policy"
          element={
            <>
              <PrivacyPolicy />
              <Footer />
            </>
          }
        />
        <Route
          path="/terms-and-conditions"
          element={
            <>
              <GeneralTerms />
              <Footer />
            </>
          }
        />
        <Route
          path="/legal-notice"
          element={
            <>
              <LegalNotice />
              <Footer />
            </>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
